import "./MGContactButtons.css"
import MGButton from "../MGButton/MGButton";

export default function MGContactButtons(
    {
        primaryLabel,
        secundaryLabel,
        primaryButtonClick,
        secondaryButtonClick,
        isButtonEnable
    }
) {
    return (
        <div className="MGContactButtons-Container">
            <MGButton label={primaryLabel} type="primary" onClick={primaryButtonClick} isEnable={isButtonEnable} />
            <MGButton label={secundaryLabel} type="secondary" onClick={secondaryButtonClick} isEnable={true} />
        </div>
    );
}